import React from 'react'
import { NumberTextBox } from '../../TextBox/NumberTextBox'
import { ISchoolTabItemProps } from './SchoolTabItem.types'

const HSCSchoolResultTabItem: React.FC<ISchoolTabItemProps> = ({
  results,
  onChange,
}) => (
  <>
    <NumberTextBox
      labelText="Exam Sat"
      value={results.exam_sat}
      onChange={(v) => onChange({ exam_sat: v })}
    />
    <NumberTextBox
      labelText="Distinguished Achievers"
      value={results.da}
      onChange={(v) => onChange({ da: v })}
    />
    <NumberTextBox
      labelText="Distinguished Achievers %"
      value={results.percentage_of_distinguished_achievers}
      onChange={(v) => onChange({ percentage_of_distinguished_achievers: v })}
    />
    <NumberTextBox
      labelText="Student enrolled"
      value={results.student_enrolled}
      onChange={(v) => onChange({ student_enrolled: v })}
    />
  </>
)

export { HSCSchoolResultTabItem }
